/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Political_Science23Inputs */

const en__field__enum_additionalstudyinterests_study_political_science23 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Political_Science23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Political Science`)
};

const de__field__enum_additionalstudyinterests_study_political_science23 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Political_Science23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politikwissenschaft`)
};

/**
* | output |
* | --- |
* | "Political Science" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Political_Science23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_political_science23 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Political_Science23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Political_Science23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_political_science23(inputs)
	return de__field__enum_additionalstudyinterests_study_political_science23(inputs)
});
export { _field__enum_additionalstudyinterests_study_political_science23 as "_field__enum_additionalStudyInterests_STUDY_POLITICAL_SCIENCE" }